<template>
  <div class="popup">
    <div class="popup_cover"></div>
    <div class="file-upload-popup">
      <div class="popup-header">
        <div class="popup_title">파일 첨부</div>
        <img src="@/assets/images/close_btn.png" @click="closePopup(false)" class="close_icon" />
      </div>
      <div class="popup-body">
        <div class="popup_desc">제목을 선택 또는 입력한 뒤 파일을 첨부해주세요.</div>
        
        <Select2 v-model="파일제목" :options="구분목록" :settings="{height:'24px',width:'100%',tags:true}" style="margin-bottom: 15px;"/>
        <div class="file_upload_area" 
          @dragover.prevent="onDragOver"
          @dragleave.prevent="onDragLeave"
          @drop.prevent="onDrop"
          @click="fileInp?.click()"
        >
          <label v-if="file1 === null" style="" >파일 첨부 +</label>
          <img v-else src="@/assets/images/file_big_icon.png" />
          <div v-if="file1 === null">또는<br/>파일놓기</div>
          <div v-else>{{ file1?.name }}</div>
        </div>
        <input ref="fileInp" class="file_inp" type="file" @change="addFile($event)" />
      </div>
      <div class="popup-footer">
        <div class="popup_close_btn" @click="closePopup(false)">취소</div>
        <div class="popup_confirm_btn" @click="uploadFile">등록</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, defineEmits, defineProps, onMounted } from "vue";
import anncounceAPI from "../../api/announceAPI";
import codeAPI from "../../api/codeAPI";

// Props 정의: 요청파일정보를 객체로 처리
const props = defineProps<{
  공고순번: number | null;
  수주수행구분: string | null;
  요청파일정보?: { 요청순번: number | null; 파일제목: string | null };
}>();

const emit = defineEmits(["closePopup"]);

// HTMLInputElement 타입을 명시적으로 지정
const fileInp = ref<HTMLInputElement | null>(null);
const 파일제목 = ref<string>("");

// Param 인터페이스 정의하여 param 타입 지정
interface Param {
  회원구분: string | null;
  파일제목: string;
  요청순번: number | null;
}

const param = ref<Param>({
  회원구분: "",
  파일제목: "",
  요청순번: null,
});

// file1 타입을 File | null로 지정
const file1 = ref<File | null>(null);
const 구분목록 = ref<{ id: string; text: string }[]>([]);
onMounted(async() => {
  await codeAPI.getSelectedCode('0002').then((res) => {
    구분목록.value = res.data.data.map((item: any) => { 
      return {id:item.코드,text:item.코드명}
    });
  });
})

const onDragOver = (event: DragEvent) => {
  event.preventDefault()
  ;(event.currentTarget as HTMLElement).classList.add('active')
  event.dataTransfer!.dropEffect = 'copy'
}
const onDragLeave = (event: DragEvent) => {
  (event.currentTarget as HTMLElement).classList.remove('active')
  event.preventDefault()
}

const onDrop = (event: DragEvent) => {
  event.preventDefault()
  const files = event.dataTransfer!.files
  if (files.length > 0) {
    const file = files[0] || null;
    file1.value = file;
    param.value.회원구분 = props.수주수행구분;
  }
}
// 파일 업로드 처리
const addFile = (event: Event) => {
  const target = event.target as HTMLInputElement;
  const file = target.files?.[0] || null;
  file1.value = file;
  param.value.회원구분 = props.수주수행구분;
};

const uploadFile = () => {
  if (!파일제목.value) {
    alert("파일 제목을 입력해주세요.");
    return;
  }
  if (!file1.value) {
    alert("파일을 첨부해주세요.");
    return;
  }

  if (props.공고순번 === null) {
    alert("공고순번이 null입니다. 파일 업로드를 진행할 수 없습니다.");
    return;
  }

  // 요청파일정보에서 요청순번과 파일제목 가져오기
  param.value.파일제목 = 파일제목.value;
  param.value.요청순번 = props.요청파일정보?.요청순번 || null;

  anncounceAPI
    .announceUploadFile(props.공고순번, param.value, file1.value)
    .then((res) => {
      if (res.data.success) {
        alert("등록이 완료되었습니다.");
        closePopup(true);
      }
    })
    .catch((error) => {
      console.error("파일 업로드 중 오류 발생:", error);
    });
};

// 팝업 닫기 처리
function closePopup(refresh: boolean) {
  emit("closePopup", { popupType: "fileUpload", refresh });
}

// 컴포넌트 초기화 처리
onMounted(() => {
  console.log("요청파일정보:", props.요청파일정보);
  if (props.요청파일정보?.파일제목) {
    파일제목.value = props.요청파일정보.파일제목;
  }
});
</script>

<style scoped>
.popup {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  left: 0px;
}
.popup_cover {
  width: 100%;
  height: 100%;
  background-color: black;
  opacity: 0.5;
}
.file-upload-popup {
  /* Add your styles here */
  left: 50%;
  position: fixed;
  background-color: white;
  width: 439px;
  height: 463px;
  background: white;
  top: calc(50% - 231.5px);
  left: calc(50% - 219.5px);
  border-radius: 11px;
}
.popup-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 71px;
  padding: 22px 27px 22px 40px;
  border-bottom: 1px solid #dbdbdb;
}
.popup_title {
  font-size: 20px;
  font-family: "Noto Sans CJK KR-Bold";
  letter-spacing: -0.05em;
  color: black;
}
.popup-body {
  /* margin-top: 10px; */
  padding: 40px;
  height: 314px;
}
.popup_desc {
  font-family: "Noto Sans CJK KR-Medium";
  font-size: 14px;
  line-height: 20px;
  color: black;
  margin-bottom: 15px;
}
.file_title {
  border: 1px solid #d0d0d0;
  height: 39px;
  width: 100%;
  border-radius: 4px;
  padding-left: 12px;
  font-size: 14px;
  font-family: "Noto Sans CJK KR-Medium";
  margin-bottom: 15px;
}
.file_upload_area {
  height: 145px;
  border: 2px dashed #dbdbdb;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #838383;
  gap: 10px;
  border-radius: 4px;
  text-align: center;
}
.file_upload_area.active {
  background-color: #f0f8ff !important;
}
.file_upload_area:hover {
  background-color: #f0f0f0 !important;
}
.file_upload_area.upload {
  cursor: default;
}
.popup-footer {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  padding: 0px 40px;
  gap: 10px;
}
.file_inp {
  width: 0px;
  height: 0px;
}
.popup_close_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ededed;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: #383838;
  font-size: 14px;
  cursor: pointer;
}
.popup_confirm_btn {
  width: 132px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #3382e9;
  border-radius: 6px;
  font-family: "Noto Sans CJK KR-Bold";
  color: white;
  font-size: 14px;
  cursor: pointer;
}
.close_icon {
  cursor: pointer;
}

.popup-body label {
  display: inline-block;
  text-align: center;
  width: 113px;
  height: 39px;
  padding: 9px 21px;
  border-radius: 4px;
  color: #000;
  vertical-align: middle;
  background-color: #fff;
  border: 1px solid #d0d0d0;
  cursor: pointer;
  font-family: "Noto Sans CJK KR-Bold";
  font-size: 14px;
}
</style>
